import angular from "angular";
import $ from "jquery";
import 'jquery-ui';
import 'jqlite';
import alertify from "./res/lib/alertifyjs/alertify.min.js";
import { addDirective } from "./directives/directive-mapping";
import { generateUploadUrl, uploadImage } from "./api/media-upload-service"
import { getImageBlob, convertHeicToJpeg } from "./utils/upload-utils"

window.$ = $;

var hasInitializedModal = false;

function initModal() {
  $("#upload_link_image_button").change(function () {
    showLinkImagePreview(this);
    $("#upload_link_image_button").attr("value", "");
  });

  $("#upload_scheduled_link_image_button").change(function () {
    showLinkImagePreview(this);
    $("#upload_scheduled_link_image_button").attr("value", "");
  });

  $("#upload_broadcast_link_image_button").change(function () {
    showLinkImagePreview(this);
    $("#upload_broadcast_link_image_button").attr("value", "");
  });

  console.log("Initialized modal.js");
  hasInitializedModal = true;
}

var canvaElements = ["#add-image-canva-button"];
var canvaCreatedElements = [];

var canvaMutationObserver = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    if (mutation.type == "childList" && mutation.target != undefined) {
      canvaCreatedElements.push(mutation.target);
    }
  });
});

function initCanvaElements() {
  console.log(
    "Initializing Canva - there are " +
    canvaElements.length +
    " Canva elements currently present."
  );

  try {
    for (var index = 0; index < canvaElements.length; index++) {
      var canvaElement = canvaElements[index];
      // de-register the onclick listener, if any
      $(canvaElement).off("click");
      $(canvaElement).removeClass();
      $(canvaElement).addClass("canva-design-button");

      // remove any dynamically created children
      $(canvaElement).empty();
    }

    // remove the old iframes
    while (canvaCreatedElements.length > 0) {
      var canvaIframe = canvaCreatedElements.pop();
      try {
        canvaIframe.parentNode.removeChild(canvaIframe);
      } catch (exception) { }
    }
  } catch (error) {
    console.error(
      "Failed to clear existing Canva elements before initializing"
    );
  }

  try {
    // initialize Canva
    (function (c, a, n) {
      var w = c.createElement(a),
        s = c.getElementsByTagName(a)[0];
      w.src = n;
      s.parentNode.insertBefore(w, s);
    })(document, "script", "https://sdk.canva.com/designbutton/v2/api.js");
  } catch (error) {
    console.error("Failed to initialize Canva");
  }
}

function createAndClickNewCanvaButton(dataAttributes) {
  var parentElement = $("#canva-button-parent");

  configureAndClickNewCanvaButton(parentElement, dataAttributes);
}

function configureAndClickNewCanvaButton(parentElement, dataAttributes) {
  var buttonId = "canva-button-" + randomId();

  // remove all children
  parentElement.empty();

  // create a new child with the appropriate attributes
  var canvaButton = document.createElement("span");
  var node = document.createTextNode("Design Media");
  canvaButton.appendChild(node);

  // add the default attributes
  canvaButton.setAttribute("id", buttonId);
  canvaButton.setAttribute("class", "canva-design-button");
  canvaButton.setAttribute("data-editor-publish-label", "Save Media");
  canvaButton.setAttribute("data-on-design-publish", "saveCanvaDesign");
  canvaButton.setAttribute("data-size", "default");
  canvaButton.setAttribute("data-editor-publish-label", "Design Custom Media");
  canvaButton.setAttribute("data-editor-file-type", "jpg");
  canvaButton.setAttribute("data-api-key", "--udGDhzWkbGkWtWuhDxRB0-");

  for (var key in dataAttributes) {
    canvaButton.setAttribute(key, dataAttributes[key]);
  }

  parentElement.append(canvaButton);

  initCanvaElements();

  setTimeout(function () {
    // track new changes being made by Canva
    canvaMutationObserver.observe(document.documentElement, {
      attributes: true,
      characterData: true,
      childList: true,
      subtree: true,
      attributeOldValue: true,
      characterDataOldValue: true,
    });

    // click the button to open Canva
    $("#" + buttonId).click();
  }, 500);

  setTimeout(function () {
    // stop listening for changes
    canvaMutationObserver.disconnect();
  }, 1000);
}

function intializeNewCanvaElement(elementId) {
  (function (c, a, n) {
    var w = c.createElement(a),
      s = c.getElementById(elementId);
    w.src = n;
    s.parentNode.insertBefore(w, s);
  })(document, "script", "https://sdk.canva.com/designbutton/v2/api.js");
}

var lastSavedCanvaDesign = undefined;

window.saveCanvaDesign = function (options) {
  var exportUrl = options.exportUrl;
  var designId = options.designId;

  if (designId == lastSavedCanvaDesign) {
    // this callback was just called
    console.log("Canva callback was just called - ignoring it.");
    return;
  }

  lastSavedCanvaDesign = designId;
  setTimeout(function () {
    lastSavedCanvaDesign = undefined;
  }, 500);

  console.log("Saving Canva Design w/ ID: " + designId);

  // added this logging for future use if want to change platform image dimensions as Canva's listed attributes don't match was gets implemented!!!
  const img = new Image();
  img.onload = function () {
    console.log(
      `Exported image dimensions: ${img.width} x ${img.height} (px)`
    );
  };
  img.onerror = function (err) {
    console.error("Failed to load exported Canva image for dimension check", err);
  };
  img.src = exportUrl;

  var scope = angular.element($("#mainControllerContext")).scope();
  scope.addCanvaImage(exportUrl, designId);
};

function randomId() {
  var S4 = function () {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  };
  return (
    S4() +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    S4() +
    S4()
  );
}

function initConfigureReportModal() {
  $("#edit-analytics-report-modal").draggable();
  console.log("Made content draggable");

  var div = $("#edit-analytics-report-modal");

  div.css("position", "fixed");
  div.css("z-index", "99");

  div.draggable({
    stop: function (event, ui) {
      var top = getTop(ui.helper);
      ui.helper.css("position", "fixed");
      ui.helper.css("z-index", "99");
      ui.helper.css("top", top + "px");
    },
  });
}

function getTop(ele) {
  var eTop = ele.offset().top;
  var wTop = $(window).scrollTop();
  var top = eTop - wTop;

  return top;
}

function initContentInfo() {
  $("#content_comment_upload").change(function () {
    showContentCommentImagePreview(this);
  });
}

function initSocialInbox() {
  console.log("Initialized social inbox");
  $("#inbox_comment_upload").change(function () {
    console.log("adding image");
    showCommentImagePreview(this);
  });
}

function showContentCommentImagePreview(input) {
  if (input.files && input.files[0]) {
    var file = input.files[0];

    var scope = angular.element($("#mainControllerContext")).scope();

    getImageBlob(file, "image/jpeg", 3, 0).then((blob) => {
      var reader = new FileReader();

      reader.onload = function (e) {
        var base64data = e.target.result;
        scope.addContentCommentImageSrc(base64data);
      };

      reader.onloadend = function (e) {
        var base64data = e.target.result;
        scope.addContentCommentImage(base64data);
      };

      reader.readAsDataURL(blob);
    });
  }
}

function showCommentImagePreview(input) {
  if (input.files && input.files[0]) {
    var file = input.files[0];

    var scope = angular.element($("#mainControllerContext")).scope();

    getImageBlob(file, "image/jpeg", 3, 0).then((blob) => {
      var reader = new FileReader();

      reader.onload = function (e) {
        var base64data = e.target.result;
        scope.addCommentImageSrc(base64data);
      };

      reader.onloadend = function (e) {
        var base64data = e.target.result;
        scope.addCommentImage(base64data);
      };

      reader.readAsDataURL(blob);
    });
  }
}

function showWhiteLabelLogoPreview(input) {
  if (input.files && input.files[0]) {
    var file = input.files[0];

    var scope = angular.element($("#mainControllerContext")).scope();

    getImageBlob(file, "image/png", 3, 0).then((blob) => {
      var reader = new FileReader();

      reader.onload = function (e) {
        var base64data = e.target.result;
        scope.addWhiteLabelLogoSrc(base64data);
      };

      reader.onloadend = function (e) {
        var base64data = e.target.result;
        scope.addWhiteLabelLogo(base64data);
      };

      reader.readAsDataURL(blob);
    });
  }
}

function showWhiteLabelLightLogoPreview(input) {
  if (input.files && input.files[0]) {
    var file = input.files[0];

    var scope = angular.element($("#mainControllerContext")).scope();

    var blob = getImageBlob(file, "image/png", 3, 0).then((blob) => {
      var reader = new FileReader();

      reader.onload = function (e) {
        var base64data = e.target.result;
        scope.addWhiteLabelLightLogoSrc(base64data);
      };

      reader.onloadend = function (e) {
        var base64data = e.target.result;
        scope.addWhiteLabelLightLogo(base64data);
      };

      reader.readAsDataURL(blob);
    });
  }
}

function showWhiteLabelFaviconPreview(input) {
  if (input.files && input.files[0]) {
    var file = input.files[0];

    var scope = angular.element($("#mainControllerContext")).scope();

    getImageBlob(file, "image/png", 3, 720).then((blob) => {
      var reader = new FileReader();

      reader.onload = function (e) {
        var base64data = e.target.result;
        scope.addWhiteLabelFaviconSrc(base64data);
      };

      reader.onloadend = function (e) {
        var base64data = e.target.result;
        scope.addWhiteLabelFavicon(base64data);
      };

      reader.readAsDataURL(blob);
    });
  }
}

function initUserSettings() {
  $("#user_picture_upload").change(function () {
    showUserPicturePreview(this);
  });
}

function showUserPicturePreview(input) {
  if (input.files && input.files[0]) {
    var file = input.files[0];

    var scope = angular.element($("#mainControllerContext")).scope();

    getImageBlob(file, "image/jpeg", 3, 0).then((blob) => {
      var reader = new FileReader();

      reader.onload = function (e) {
        var base64data = e.target.result;
        scope.addUserPictureSrc(base64data);
      };

      reader.onloadend = function (e) {
        var base64data = e.target.result;
        scope.addUserPicture(base64data);
      };

      reader.readAsDataURL(blob);
    });
  }
}

function showImagePreview(input) {
  if (input.files && input.files.length > 0) {
    var scope = angular.element($("#mainControllerContext")).scope();
    scope.toggleLoadingImagePreview(true);

    console.log("Adding " + input.files.length + " images");

    angular.forEach(input.files, function (file) {
      getImageBlob(file, "image/jpeg", 3, 0).then((blob) => {
        var reader = new FileReader();

        reader.onloadend = function (e) {
          var base64data = e.target.result;
          readContentImageBlob(base64data, file);
        };

        reader.readAsDataURL(blob);
      });
    });
  }
}

function showWatermarkPreview(input) {
  if (input.files && input.files[0]) {
    var scope = angular.element($("#mainControllerContext")).scope();

    console.log("Adding " + input.files.length + " images");

    var file = input.files[0];

    getImageBlob(file, "image/png", 3, 0).then((blob) => {
      var reader = new FileReader();

      reader.onloadend = function (e) {
        var base64data = e.target.result;
        readWatermarkImageBlob(base64data);
      };

      reader.readAsDataURL(blob);
    });
  }
}

function readWatermarkImageBlob(mediaData) {
  var scope = angular.element($("#mainControllerContext")).scope();
  scope.addWatermarkImage(mediaData);
}

function readContentImageBlob(mediaData, file) {
  var mediaId = randomId();

  var scope = angular.element($("#mainControllerContext")).scope();
  scope.addMediaFileSrcMultiple(mediaData, mediaId, file);
  scope.addMediaFileMultiple(mediaData, mediaId);
}

function readContentImageBlobForBulkUpload(mediaData, fileName) {
  var mediaId = randomId();

  var scope = angular.element($("#mainControllerContext")).scope();
  scope.uploadMediaFile(fileName, mediaData);
}

function showImagePreviewOld(input) {
  if (input.files) {
    var fileId = randomId();

    var scope = angular.element($("#mainControllerContext")).scope();

    getImageBlob(file, "image/jpeg", 3, 0).then((blob) => {
      var reader = new FileReader();

      reader.onload = function (e) {
        var base64data = e.target.result;
        scope.addMediaFileSrcMultiple(base64data, fileId);
      };

      reader.onloadend = function (e) {
        var base64data = e.target.result;
        scope.addMediaFileMultiple(base64data, fileId);
      };

      reader.readAsDataURL(blob);
    });
  }
}

function showLinkImagePreview(input) {
  if (input.files && input.files[0]) {
    const file = input.files[0];
    const scope = angular.element($("#mainControllerContext")).scope();
    let fileExtension = (file.name.split('.').pop() || '').toLowerCase();

    (async () => {
      try {
        let blob = file;
        
        if (["heic", "heif"].includes(fileExtension)) {
          blob = await new Promise((resolve, reject) => {
            try {
              convertHeicToJpeg(file, file.size, 3, 1200, "image/jpeg", resolve);
            } catch (e) {
              reject(e);
            }
          });
          fileExtension = "jpg";
        }

        const imageUrl = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });

        const uploadUrl = await generateUploadUrl(fileExtension);
        const imageUploadUrl = await uploadImage({
          addWatermark: false,
          imageUploadUrl: uploadUrl,
          mediaFile: imageUrl,
        });

        scope.addLinkMediaFileSrc(imageUploadUrl);
        scope.contentBeingEdited.websiteMeta.edited = true;
      } catch (err) {
        console.log(err);
      }
    })();
  }
}


function showVideoPreview(input) {
  if (input.files && input.files[0]) {
    var file = input.files[0];
    var mime = file.type;

    var fileSize = (file.size / 1024 / 1024).toFixed(4); // MB

    console.log("Video is size: " + fileSize + " MB");

    var reader = new FileReader();

    var scope = angular.element($("#mainControllerContext")).scope();

    /* reader.onload = function (e) {
          console.log("video - onload");
            scope.addVideoFileSrc(e.target.result);
        } */

    reader.onload = function (e) {
      var blob = new Blob([e.target.result], { type: mime });
      var url = (URL || webkitURL).createObjectURL(blob);

      console.log("video - onload");
      scope.addVideoFileSrc(url);
    };

    reader.onloadend = function (e) {
      console.log("video - onload end");
      var blob = new Blob([e.target.result], { type: mime });
      // save the file in an angular variable
      scope.addVideoFile(blob, file);
    };

    if (fileSize > 512) {
      console.log("Video is too large - " + fileSize + " MB.");

      alertify
        .alert(
          "",
          "The max video size is 512MB.  Your video is " +
          Number(fileSize).toFixed(1) +
          "MB."
        )
        .setting({
          label: "Ok",
        });
    } else {
      scope.toggleLoadingImagePreview(true);
      reader.readAsArrayBuffer(file);
      // reader.readAsDataURL(file);
    }
  }
}

function closeEverGreenContentModal() {
  $("#create_evergreen_content_directive").hide();
  makeMainContentScrollable();
}

var hasLink = false;

function trackCharacterCount() {
  var twitterLimit = 280;
  var twitterLinkLength = 28;
  var wasRed = false;

  //#d8dfea

  $("#content_text_area").keyup(function () {
    var textLength = $("#content_text_area").val().length;
    var charCountDiv = $("#content_char_count");

    var scope = angular.element($("#mainControllerContext")).scope();
    hasLink = scope.contentBeingEdited.hasLink;

    if (hasLink) {
      textLength += twitterLinkLength;
    }
  });
}

function showLoginModal() {
  $("#login_modal_directive").show();

  makeMainContentFixed();
}

function hideLoginModal() {
  $("#login_modal_directive").hide();

  makeMainContentScrollable();
}

function showModal() {
  addDirective("create_evergreen_content_directive");
  $("#create_evergreen_content_directive").show();

  makeMainContentFixed();
}

function hideModal() {
  $("#create_evergreen_content_directive").hide();

  makeMainContentScrollable();
}

function showAddContentModal() {
  addDirective("add_content_directive");
  $("#add_content_directive").show();

  makeMainContentFixed();
}

function hideAddContentModal() {
  $("#add_content_directive").hide();

  makeMainContentScrollable();
}

function showAddImagesModal() {
  addDirective("add_images_directive");
  $("#add_images_directive").show();

  makeMainContentFixed();
}

function hideAddImagesModal() {
  $("#add_images_directive").hide();

  makeMainContentScrollable();
}

function showScheduleContentModal() {
  addDirective("schedule_content_modal");
  $("#schedule_content_modal").show();

  makeMainContentFixed();
}

function hideScheduleContentModal() {
  $("#schedule_content_modal").hide();

  makeMainContentScrollable();
}

function showBackdatePostModal() {
  addDirective("backdate_post_modal");
  $("#backdate_post_modal").show();

  makeMainContentFixed();
}

function hideBackdatePostModal() {
  $("#backdate_post_modal").hide();

  makeMainContentScrollable();
}

function showPostBackdatedContentModal() {
  addDirective("post_backdated_content_modal");
  $("#post_backdated_content_modal").show();

  makeMainContentFixed();
}

function hidePostBackdatedContentModal() {
  $("#post_backdated_content_modal").hide();

  makeMainContentScrollable();
}

function showScheduleBroadcastModal() {
  addDirective("schedule_broadcast_modal");
  $("#schedule_broadcast_modal").show();

  makeMainContentFixed();
}

function hideScheduleBroadcastModal() {
  $("#schedule_broadcast_modal").hide();

  makeMainContentScrollable();
}

function showAnalyticsAnnotationModal() {
  $("#create_analytics_annotation_directive").show();

  makeMainContentFixed();
}

function hideAnalyticsAnnotationModal() {
  $("#create_analytics_annotation_directive").hide();

  makeMainContentScrollable();
}

function showAnalyticsReportModal() {
  $("#create_analytics_report_directive").show();

  makeMainContentFixed();
}

function hideAnalyticsReportModal() {
  $("#create_analytics_report_directive").hide();

  makeMainContentScrollable();
}

function showBulkAnalyticsReportModal() {
  addDirective("bulk_create_analytics_report_directive");
  $("#bulk_create_analytics_report_directive").show();

  makeMainContentFixed();
}

function hideBulkAnalyticsReportModal() {
  $("#bulk_create_analytics_report_directive").hide();

  makeMainContentScrollable();
}

function showAnalyticsReportCoverPageModal() {
  $("#analytics_report_cover_page_directive").show();

  makeMainContentFixed();
}

function hideAnalyticsReportCoverPageModal() {
  $("#analytics_report_cover_page_directive").hide();

  makeMainContentScrollable();
}

function showUpdateAnalyticsReportCoverPageModal() {
  $("#update_analytics_report_cover_page_directive").show();

  makeMainContentFixed();
}

function hideUpdateAnalyticsReportCoverPageModal() {
  $("#update_analytics_report_cover_page_directive").hide();

  makeMainContentScrollable();
}

function showAutoImportSourceModalDirective() {
  addDirective("create_auto_import_source_directive");
  $("#create_auto_import_source_directive").show();

  makeMainContentFixed();
}

function hideAutoImportSourceModal() {
  $("#create_auto_import_source_directive").hide();

  makeMainContentScrollable();
}

function showChooseContentTagModal() {
  addDirective("choose_content_tag_modal_directive");
  $("#choose_content_tag_modal_directive").show();

  makeMainContentFixed();
}

function hideChooseContentTagModal() {
  $("#choose_content_tag_modal_directive").hide();

  makeMainContentScrollable();
}

function showEditContentTagModal() {
  addDirective("edit_content_tag_modal_directive");
  $("#edit_content_tag_modal_directive").show();

  makeMainContentFixed();
}

function hideEditContentTagModal() {
  $("#edit_content_tag_modal_directive").hide();

  makeMainContentScrollable();
}

function showChooseContentTagForAutoImporterModal() {
  addDirective("choose_content_tag_ai_modal_directive");
  $("#choose_content_tag_ai_modal_directive").show();

  makeMainContentFixed();
}

function hideChooseContentTagForAutoImporterModal() {
  $("#choose_content_tag_ai_modal_directive").hide();

  makeMainContentScrollable();
}

function showManageHashtagModal() {
  showManageHashtagsModal();
}

function showManageHashtagsModal() {
  addDirective("manage_hashtags_modal_directive");
  $("#manage_hashtags_modal_directive").show();

  makeMainContentFixed();
}

function hideManageHashtagModal() {
  hideManageHashtagsModal();
}

function hideManageHashtagsModal() {
  $("#manage_hashtags_modal_directive").hide();

  makeMainContentScrollable();
}

function showManageCannedResponseModal() {
  addDirective("manage_canned_response_modal_directive");
  $("#manage_canned_response_modal_directive").show();

  makeMainContentFixed();
}

function hideManageCannedResponseModal() {
  $("#manage_canned_response_modal_directive").hide();

  makeMainContentScrollable();
}

function showTriggerAutoFillModal() {
  addDirective("trigger_auto_fill_modal_directive");
  $("#trigger_auto_fill_modal_directive").show();

  makeMainContentFixed();
}

function hideTriggerAutoFillModal() {
  $("#trigger_auto_fill_modal_directive").hide();

  makeMainContentScrollable();
}

function showUploadMediaModal() {
  addDirective("upload_media_modal_directive");
  $("#upload_media_modal_directive").show();

  makeMainContentFixed();
}

function hideUploadMediaModal() {
  $("#upload_media_modal_directive").hide();

  makeMainContentScrollable();
}

function showUploadContentCsvModal() {
  addDirective("upload_content_csv_modal_directive");
  $("#upload_content_csv_modal_directive").show();

  makeMainContentFixed();
}

function hideUploadContentCsvModal() {
  $("#upload_content_csv_modal_directive").hide();

  makeMainContentScrollable();
}

function showRoiDataModal() {
  addDirective("edit_roi_data_modal_directive");
  $("#edit_roi_data_modal_directive").show();

  makeMainContentFixed();
}

function hideRoiDataModal() {
  $("#edit_roi_data_modal_directive").hide();

  makeMainContentScrollable();
}

function showCampaignResultsModal() {
  $("#add_campaign_results_modal_directive").show();

  makeMainContentFixed();
}

function hideCampaignResultsModal() {
  $("#add_campaign_results_modal_directive").hide();

  makeMainContentScrollable();
}

function showUpcomingPostModal() {
  addDirective("upcoming_post_modal_directive");
  $("#upcoming_post_modal_directive").show();

  makeMainContentFixed();
}

function hideUpcomingPostModal() {
  $("#upcoming_post_modal_directive").hide();

  makeMainContentScrollable();
}

function showAddBrandModal() {
  addDirective("add_brand_modal_directive");
  $("#add_brand_modal_directive").show();

  makeMainContentFixed();
}

function hideAddBrandModal() {
  $("#add_brand_modal_directive").hide();

  makeMainContentScrollable();
}

function showAddUserModal() {
  addDirective("add_user_modal_directive");
  $("#add_user_modal_directive").show();

  makeMainContentFixed();
}

function hideAddUserModal() {
  $("#add_user_modal_directive").hide();

  makeMainContentScrollable();
}

function showEditUserModal() {
  addDirective("edit_user_modal_directive");
  $("#edit_user_modal_directive").show();

  makeMainContentFixed();
}

function hideEditUserModal() {
  $("#edit_user_modal_directive").hide();

  makeMainContentScrollable();
}

function showImportExistingPostsModal() {
  addDirective("import_existing_content_modal_directive");
  $("#import_existing_content_modal_directive").show();

  makeMainContentFixed();
}

function hideImportExistingPostsModal() {
  $("#import_existing_content_modal_directive").hide();

  makeMainContentScrollable();
}

function showCreateContentApprovalModalDirective() {
  addDirective("create_content_approval_modal_directive");
  $("#create_content_approval_modal_directive").show();

  makeMainContentFixed();
}

function hideCreateContentApprovalModal() {
  $("#create_content_approval_modal_directive").hide();

  makeMainContentScrollable();
}

// Modal for Admins to update whitelabel settings.
function showAdminWLSettingsModal() {
  addDirective("admin_wl_settings_modal");
  $("#admin-wl-settings-modal").show();

  makeMainContentFixed();
}

function hideAdminWLSettingsModal() {
  $("#admin-wl-settings-modal").hide();

  makeMainContentScrollable();
}

function showMobileFilterSocialInboxModal() {
  addDirective("mobile_filter_social_inbox_modal");
  $("#mobile_filter_social_inbox_modal").show();

  makeMainContentFixed();
}

function hideMobileFilterSocialInboxModal() {
  $("#mobile_filter_social_inbox_modal").hide();

  makeMainContentScrollable();
}

// Modals to create CloudConnect Invite Links
function showCreateInviteLinkModalDirective() {
  addDirective("create_invite_link_modal_directive");
  $("#create_invite_link_modal_directive").show();

  makeMainContentFixed();
}

function hideCreateInviteLinkModal() {
  $("#create_invite_link_modal_directive").hide();

  makeMainContentScrollable();
}

function showBulkManageContentModal() {
  addDirective("bulk_manage_content_modal_directive");
  $("#bulk_manage_content_modal_directive").show();

  makeMainContentFixed();
}

function hideBulkManageContentModal() {
  $("#bulk_manage_content_modal_directive").hide();

  makeMainContentScrollable();
}

function showBillingDisclaimerModal() {
  addDirective("billing_disclaimer_modal_directive");
  $("#billing_disclaimer_modal_directive").show();

  makeMainContentFixed();
}

function hideBillingDisclaimerModal() {
  $("#billing_disclaimer_modal_directive").hide();

  makeMainContentScrollable();
}

function showAddToQueueModal() {
  addDirective("add_to_queue_modal_directive");
  $("#add_to_queue_modal_directive").show();

  makeMainContentFixed();
}

function hideAddToQueueModal() {
  $("#add_to_queue_modal_directive").hide();

  makeMainContentScrollable();
}

function showTrialExpiredModal() {
  addDirective("trial_account_expired_modal");
  $("#trial_account_expired_modal").show();

  makeMainContentFixed();
}

function showAuthorizePlatformModal() {
  addDirective("authorize_platform_modal");
  $("#authorize_platform_modal").show();

  makeMainContentFixed();
}

function hideAuthorizePlatformModal() {
  $("#authorize_platform_modal").hide();

  makeMainContentScrollable();
}

function showAssignMessageModal() {
  addDirective("assign_message_modal_directive");
  $("#assign_message_modal_directive").show();

  makeMainContentFixed();
}

function hideAssignMessageModal() {
  $("#assign_message_modal_directive").hide();

  makeMainContentScrollable();
}

function showReorderQueueModal() {
  addDirective("reorder_queue_modal_directive");
  $("#reorder_queue_modal_directive").show();

  makeMainContentFixed();
}

function hideReorderQueueModal() {
  $("#reorder_queue_modal_directive").hide();

  makeMainContentScrollable();
}

function showAuthorizeAppModal() {
  $("#authorize_app_modal_directive").show();

  makeMainContentFixed();
}

function hideAuthorizeAppModal() {
  $("#authorize_app_modal_directive").hide();

  makeMainContentScrollable();
}

function showMobileCommentModal() {
  $("#mobile_comment_modal_directive").show();

  makeMainContentFixed();
}

function hideMobileCommentModal() {
  $("#mobile_comment_modal_directive").hide();

  makeMainContentScrollable();
}

function showContestTermsModal() {
  $("#contest_terms_modal_directive").show();

  makeMainContentFixed();
}

function hideContestTermsModal() {
  $("#contest_terms_modal_directive").hide();

  makeMainContentScrollable();
}

function showSelectIntegrationModal() {
  addDirective("select_integration_modal_directive");
  $("#select_integration_modal_directive").show();

  makeMainContentFixed();
}

function hideSelectIntegrationModal() {
  $("#select_integration_modal_directive").hide();

  makeMainContentScrollable();
}

function showDemoGate() {
  addDirective("dashboard_demo_gate");
  $("#dashboard_demo_gate").fadeIn();
  $("#main_content_parent").addClass("blur");

  makeMainContentFixed();
}

function hideDemoGate() {
  $("#dashboard_demo_gate").fadeOut();
  $("#main_content_parent").removeClass("blur");

  makeMainContentScrollable();
}

function showRelinkAccountsModal() {
  $("#relink_accounts_modal_directive").show();

  makeMainContentFixed();
}

function hideRelinkAccountsModal() {
  $("#relink_accounts_modal_directive").hide();

  makeMainContentScrollable();
}

function showCreateScheduleModal() {
  addDirective("create_schedule_modal_directive");
  $("#create_schedule_modal_directive").show();

  makeMainContentFixed();
}

function hideCreateScheduleModal() {
  $("#create_schedule_modal_directive").hide();

  makeMainContentScrollable();
}

function showAuthorizeGroupsModal() {
  addDirective("authorize_groups_modal_directive");
  $("#authorize_groups_modal_directive").show();

  makeMainContentFixed();
}

function hideAuthorizeGroupsModal() {
  $("#authorize_groups_modal_directive").hide();

  makeMainContentScrollable();
}

function showChooseLinkIconModal() {
  $("#choose_link_icon_modal_directive").show();

  makeMainContentFixed();
}

function hideChooseLinkIconModal() {
  $("#choose_link_icon_modal_directive").hide();

  makeMainContentScrollable();
}

function showSelectDefaultSubAccountsModal() {
  addDirective("select_default_sub_accounts_modal_directive");
  $("#select_default_sub_accounts_modal_directive").show();

  makeMainContentFixed();
}

function hideSelectDefaultSubAccountsModal() {
  $("#select_default_sub_accounts_modal_directive").hide();

  makeMainContentScrollable();
}

function showSelectPostSubAccountsModal() {
  addDirective("select_post_sub_accounts_modal_directive");
  $("#select_post_sub_accounts_modal_directive").show();

  makeMainContentFixed();
}

function hideSelectPostSubAccountsModal() {
  $("#select_post_sub_accounts_modal_directive").hide();

  makeMainContentScrollable();
}

function showAmbassadorModal() {
  addDirective("ambassador_modal_directive");
  $("#ambassador_modal_directive").show();

  makeMainContentFixed();
}

function hideAmbassadorModal() {
  $("#ambassador_modal_directive").hide();

  makeMainContentScrollable();
}

function makeMainContentScrollable() {
  if ($("#main_content").length > 0) {
    $("#main_content").css("overflow-y", "scroll");
  }
}

function makeMainContentFixed() {
  if ($("#main_content").length > 0) {
    $("#main_content").css("overflow-y", "hidden");
  }
}

export {
  initModal,
  initCanvaElements,
  createAndClickNewCanvaButton,
  configureAndClickNewCanvaButton,
  intializeNewCanvaElement,
  randomId,
  initConfigureReportModal,
  getTop,
  initContentInfo,
  initSocialInbox,
  showContentCommentImagePreview,
  showCommentImagePreview,
  showWhiteLabelLogoPreview,
  showWhiteLabelLightLogoPreview,
  showWhiteLabelFaviconPreview,
  initUserSettings,
  showUserPicturePreview,
  showImagePreview,
  showWatermarkPreview,
  readWatermarkImageBlob,
  readContentImageBlob,
  readContentImageBlobForBulkUpload,
  showImagePreviewOld,
  showLinkImagePreview,
  showVideoPreview,
  closeEverGreenContentModal,
  trackCharacterCount,
  showLoginModal,
  hideLoginModal,
  showModal,
  hideModal,
  showAddContentModal,
  hideAddContentModal,
  showAddImagesModal,
  hideAddImagesModal,
  showScheduleContentModal,
  hideScheduleContentModal,
  showBackdatePostModal,
  hideBackdatePostModal,
  showPostBackdatedContentModal,
  hidePostBackdatedContentModal,
  showScheduleBroadcastModal,
  hideScheduleBroadcastModal,
  showAnalyticsAnnotationModal,
  hideAnalyticsAnnotationModal,
  showAnalyticsReportModal,
  hideAnalyticsReportModal,
  showBulkAnalyticsReportModal,
  hideBulkAnalyticsReportModal,
  showAnalyticsReportCoverPageModal,
  hideAnalyticsReportCoverPageModal,
  showUpdateAnalyticsReportCoverPageModal,
  hideUpdateAnalyticsReportCoverPageModal,
  showAutoImportSourceModalDirective,
  hideAutoImportSourceModal,
  showChooseContentTagModal,
  hideChooseContentTagModal,
  showEditContentTagModal,
  hideEditContentTagModal,
  showChooseContentTagForAutoImporterModal,
  hideChooseContentTagForAutoImporterModal,
  showManageHashtagModal,
  showManageHashtagsModal,
  hideManageHashtagModal,
  hideManageHashtagsModal,
  showManageCannedResponseModal,
  hideManageCannedResponseModal,
  showTriggerAutoFillModal,
  hideTriggerAutoFillModal,
  showUploadMediaModal,
  hideUploadMediaModal,
  showUploadContentCsvModal,
  hideUploadContentCsvModal,
  showRoiDataModal,
  hideRoiDataModal,
  showCampaignResultsModal,
  hideCampaignResultsModal,
  showUpcomingPostModal,
  hideUpcomingPostModal,
  showAddBrandModal,
  hideAddBrandModal,
  showAddUserModal,
  hideAddUserModal,
  showEditUserModal,
  hideEditUserModal,
  showImportExistingPostsModal,
  hideImportExistingPostsModal,
  showCreateContentApprovalModalDirective,
  hideCreateContentApprovalModal,
  showAdminWLSettingsModal,
  hideAdminWLSettingsModal,
  showCreateInviteLinkModalDirective,
  hideCreateInviteLinkModal,
  showBulkManageContentModal,
  hideBulkManageContentModal,
  showBillingDisclaimerModal,
  hideBillingDisclaimerModal,
  showAddToQueueModal,
  hideAddToQueueModal,
  showTrialExpiredModal,
  showAuthorizePlatformModal,
  hideAuthorizePlatformModal,
  showAssignMessageModal,
  hideAssignMessageModal,
  showReorderQueueModal,
  hideReorderQueueModal,
  showAuthorizeAppModal,
  hideAuthorizeAppModal,
  showMobileCommentModal,
  hideMobileCommentModal,
  showContestTermsModal,
  hideContestTermsModal,
  showSelectIntegrationModal,
  hideSelectIntegrationModal,
  showDemoGate,
  hideDemoGate,
  showRelinkAccountsModal,
  hideRelinkAccountsModal,
  showCreateScheduleModal,
  hideCreateScheduleModal,
  showAuthorizeGroupsModal,
  hideAuthorizeGroupsModal,
  showChooseLinkIconModal,
  hideChooseLinkIconModal,
  showSelectDefaultSubAccountsModal,
  hideSelectDefaultSubAccountsModal,
  showSelectPostSubAccountsModal,
  hideSelectPostSubAccountsModal,
  showAmbassadorModal,
  hideAmbassadorModal,
  makeMainContentScrollable,
  makeMainContentFixed,
  showMobileFilterSocialInboxModal,
  hideMobileFilterSocialInboxModal
};
